import { Component, ElementRef, Input, OnDestroy, OnInit, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { UiService } from '../../services/ui.service';
import { Globals } from '../../globals';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MessagingService } from '../../services/messaging.service';
import { StaticDataService } from '../../services/static-data.service';
import { CommMethodEnum } from '../../models/enum/comm-method.enum';
import * as moment from 'moment';
import { LOCID } from '../../constants';
import { PatientDialogDataModel } from '../../modules/patient/patient-dialog-data.model';
import { PatientEditComponent } from '../../modules/patient/patient-edit/patient-edit.component';
import { fromEvent, Subscription } from 'rxjs';
import { PatientService } from '../../modules/patient/patient.service';
import { TdoNoteBuilderComponent } from '../controls/tdo-note-builder/tdo-note-builder.component';
import { PatientSearchModel } from '../../models/patient/patient-search.model';
import { MatOptionSelectionChange } from '@angular/material/core';
import { MessagingConstants } from '../../models/MessagingConstants';
import { FileManagerService } from '../../modules/file-manager/file-manager.service';
import { SignalrService } from '../../services/socket/signalr.service';
import { AuthenticationService } from '../../modules/auth/services/authentication.service';
import { UserRoleEnum } from '../../models/enum/user-role.enum';
import { TdoPatientSearchComponent } from '../../tdo-controls/tdo-patient-search/tdo-patient-search.component';
import { dataPatientCaseWorkItem } from '../../modules/ar/_models/ar.models';
import { TemplatePortal } from '@angular/cdk/portal';
import { filter, take } from 'rxjs/operators';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { SecureImagePipe } from 'src/app/pipes/secure-image.pipe';
import { DOCUMENT_TAG } from 'src/app/models/constants/document-tag.model';
import { DocumentDataModel } from 'src/app/models/document/document-data.model';
import { Router } from '@angular/router';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit, OnDestroy {
  @ViewChild('tps') patientInputSearch: TdoPatientSearchComponent;
  @ViewChild('pasteMenu') pasteMenu: TemplateRef<any>;

  isTopExpanded: boolean = true;
  isShowPatientSearch = false;
  moment = moment;

  searchString: string = '';

  refreshingImages: boolean = false;
  locid: number = 0;

  currentPatient: any;
  currentPatientDoctors: any;
  patientBirthday: moment.Moment;
  patientAddress: string = '';
  patientPhoneNum: string = '';
  patientDifficultyEnum: string = '';

  isPrivateInfoVisible: boolean = false;
  patientSearchList: PatientSearchModel[] = [];

  isActionCheckOut: boolean = false;

  private msgSub: Subscription;
  patientPictureSrc: string = 'assets/Images/defaultPatient.PNG';
  isContextOpen = false;
  private overlayRef: OverlayRef | null;
  private sub: Subscription;

  constructor(public uiService: UiService, public globals: Globals, private dialog: MatDialog,
    private signalrService: SignalrService,
    private fileService: FileManagerService,
    private messagingService: MessagingService,
    private staticDataService: StaticDataService,
    private authenticationService: AuthenticationService,
    private patientService: PatientService,
    private viewContainerRef: ViewContainerRef,
    private overlay: Overlay,
    private router: Router) { }

  ngOnInit(): void {
    if (localStorage.getItem(LOCID)) {
      this.locid = parseInt(localStorage.getItem(LOCID));
    }

    if(this.globals.ThePatient===null || this.globals.ThePatient===undefined)  {

      this.messagingService.broadCastMessage(MessagingConstants.PATIENT_CHANGED, {
        PatientID: this.globals.currentPatientId,
        clearCurrentQuery: true,


      });

    }

    this.initPatient(this.globals.ThePatient);

    this.msgSub = this.messagingService.componentMessageCall.subscribe(response => {
      if (response.event === MessagingConstants.PATIENT_LOADED) {
        this.initPatient(this.globals.ThePatient);
      }
      else if (response.event === (MessagingConstants.HEADER_MINIMIZE)) {
        this.isTopExpanded = false;
      }
    });

    this.signalrService.messageUser.subscribe((res) => {
      if (res.messageType === SignalrService.UPDATE_PROFILE) {
        if (res.message && res.message['patientId'] && res.message['patientId'] === this.globals.currentPatientId) {
          this.initPatient(this.globals.ThePatient);
        }
      }
      else if (res.messageType === 'UPDATE_PATIENT_PICTURE') {

        if (res.message && res.message['patientId'] && res.message['patientId'] === this.globals.currentPatientId) {

          this.fileService.getPatientPictureClearCache(this.globals.currentPatientId).subscribe((res2) => {

            this.fileService.getPatientPicture(this.globals.currentPatientId + '?' + new Date().toString()).subscribe((res) => {

              if (res) {
                this.patientPictureSrc = this.fileService.getDocumentUrlFromDocument(res);
              } else {
                this.patientPictureSrc = 'assets/Images/defaultPatient.PNG';
              }
            });
          });
        } else {
          this.patientPictureSrc = 'assets/Images/defaultPatient.PNG';
        }

      }
    });
  }

  ngOnDestroy() {
    if (this.msgSub)
      this.msgSub.unsubscribe();
  }

  onDifficultySelectionChange(event) {
  }

  onProfileClick() {
    this.openEditPatient();
  }

  openEditPatient() {
    const dm = new PatientDialogDataModel();
    dm.title = 'Edit Patient';
    dm.mode = PatientDialogDataModel.MODE_EDIT_PATIENT;
    dm.entityId = this.globals.currentPatientId;

    const config = new MatDialogConfig();
    config.width = '968px';
    config.height = '562px';
    config.data = dm;
    config.panelClass = 'tdo-note-dialog-main';

    const dialogRef = this.dialog.open(PatientEditComponent, config);

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (result.patientDeleted) {
          // Patient was deleted, refresh the page to clear patient data
          this.router.navigate(['/']);
          return;
        }
        
        this.messagingService.broadCastMessage(MessagingConstants.PATIENT_CHANGED, {
          PatientID: this.globals.currentPatientId,
          clearCurrentQuery: false,
        });

        this.initPatient(result);
      }
    }, err => {
      console.log(err);
    });
  }

  onAddPatientClick() {
    const dm = new PatientDialogDataModel();
    dm.mode = PatientDialogDataModel.MODE_NEW_PATIENT;
    dm.title = 'New Patient';
    //dm.initWebId = true;
    dm.entityType = PatientDialogDataModel.TYPE_PATIENT;

    const config = new MatDialogConfig();
    config.width = '968px';
    config.height = '562px';
    config.panelClass = 'tdo-note-dialog-main';
    config.data = dm;

    const dialogRef = this.dialog.open(PatientEditComponent, config);

    dialogRef.afterClosed().subscribe(result => {

      if (result) {
        this.globals.currentPatientSelectedCaseItem = undefined;
        this.globals.save();

        this.messagingService.broadCastMessage(MessagingConstants.PATIENT_CHANGED, {
          PatientID: result.ThePatient.PatientId,
          clearCurrentQuery: false,
        });
        this.messagingService.sendComponentMessage('START-REASON-FOR-VISIT', '');
      }
    }, err => {
      console.log(err);
    });

  }

  getDifficultyLevel() {
    switch (this.patientDifficultyEnum) {
      case '00000000-0000-0000-0000-000000000000':
        return 'N/A';
      case '00000107-1000-0000-0000-000000000001':
        return 'T1';
      case '00000107-1000-0000-0000-000000000002':
        return 'T2';
      case '00000107-1000-0000-0000-000000000003':
        return 'T3';
      default:
        return 'N/A';
    }
  }

  onPrivacyClick() {
    this.isPrivateInfoVisible = !this.isPrivateInfoVisible;
    // Hide content in 30 minutes
    if (this.isPrivateInfoVisible) {
      setTimeout(() => {
        this.isPrivateInfoVisible = false;
      }, 1800000);
    }
  }

  async getPatientPicture(PatientId : string) {
    let url = 'assets/Images/defaultPatient.PNG';
    if (PatientId !== 'null' && PatientId !== 'undefined' && PatientId !== null && PatientId !== undefined) {
    //this.fileService.getPatientPictureClearCache(PatientId).toPromise();
    const res: DocumentDataModel = await this.fileService.getPatientPicture(PatientId + '?' + new Date().toString()).toPromise();
    if (res) {
      url = this.fileService.getDocumentUrlFromDocument(res);
    }
  }
    return url;
  }

  private async initPatient(newPatient: any): Promise<void> {
    // Reset patient data if no patient is selected
    if (newPatient === null || newPatient === undefined) {
      this.patientPictureSrc = 'assets/Images/defaultPatient.PNG';
      this.currentPatient = null;
      this.patientBirthday = null;
      this.patientAddress = '';
      this.patientPhoneNum = '';
      this.patientDifficultyEnum = '';
      this.currentPatientDoctors = [];
      // Reset global patient data
      this.globals.currentPatientCaseWorkItemID = '';
      this.globals.currentPatientCaseWorkItem = new dataPatientCaseWorkItem();
      return;
    }

    if (newPatient.dataContact === null || newPatient.dataContact === undefined) {
      this.patientPictureSrc = 'assets/Images/defaultPatient.PNG';
      this.currentPatient = newPatient;
      this.patientBirthday = null;
      this.patientAddress = '';
      this.patientPhoneNum = '';
      this.patientDifficultyEnum = '';
      this.currentPatientDoctors = [];
      return;
    }

    // Check if a patient picture exists in the file system.
    if (this.globals.currentPatientId && newPatient && newPatient.patientImageUrl) {
      this.patientPictureSrc = newPatient?.patientImageUrl ? this.fileService.getDocumentImageUrl(this.globals.currentPatientId, newPatient?.patientImageUrl) : '/assets/Images/defaultPatient.PNG';
    } else {
      this.patientPictureSrc = await this.getPatientPicture(this.globals.currentPatientId);
    }
    
    // reset current case work item after logging in
    this.globals.currentPatientCaseWorkItemID = '';
    this.globals.currentPatientCaseWorkItem = new dataPatientCaseWorkItem();

    this.currentPatient = newPatient;
    this.patientBirthday = newPatient.BirthDate ? moment(newPatient.BirthDate) : null;

    const firstName : string = newPatient.dataContact.FirstName || '';
    const midName : string = newPatient.dataContact.MidName || '';
    const lastName  : string = newPatient.dataContact.LastName || '';
    this.globals.currentPatientFullName = `${firstName} ${midName} ${lastName}`;
    this.globals.save();

    const address = newPatient.dataContact.dataAddresses[0];

    const hasAddr = address !== null && address !== undefined;
    this.patientAddress = 'No address';

    if (hasAddr) {
      this.patientAddress = '';
      if (address.Address1) { this.patientAddress += address.Address1; }
      if (address.Address2) { this.patientAddress += ` ${address.Address1}`; }
      if (address.City) { this.patientAddress += ` ${address.City}`; }
      if (address.State) { this.patientAddress += `, ${address.State}`; }
      if (address.PostCode) { this.patientAddress += ` ${address.PostCode}`; }
    }

    const phoneNums = newPatient.dataContact.dataContactComms
      .filter(o => o.enumCommMethodID === CommMethodEnum.Phone || o.enumCommMethodID === CommMethodEnum.Mobile);

    if (phoneNums.length > 0) {
      const preferredNum = phoneNums.find(o => o.isPreferred);

      if (preferredNum !== null && preferredNum !== undefined) {
        this.patientPhoneNum = preferredNum.Address;
      }
      else {
        this.patientPhoneNum = phoneNums[0].Address;
      }
    }
    else {
      this.patientPhoneNum = 'No phone number';
    }

    this.patientDifficultyEnum = this.currentPatient.enumPatientDifficultyLevelID;

    this.currentPatientDoctors = [];

    newPatient.dataPatientDoctors.forEach(patientDoctor => {
      if (patientDoctor.dataDoctorSpecialty && patientDoctor.dataDoctorSpecialty.dataDoctor && patientDoctor.dataDoctorSpecialty.dataDoctor.dataContact) {
        const dataDoctor = patientDoctor.dataDoctorSpecialty.dataDoctor;
        const dataDoctorContact = dataDoctor.dataContact;

        const doctorName = `Dr. ${dataDoctorContact.FirstName} ${dataDoctorContact.LastName}`;
        const isReferring = patientDoctor.isReferring;

        const obj = {
          name: doctorName,
          isReferring
        };

        this.currentPatientDoctors.push(obj);
      }
    });
  }

  changeDifficultyLevel() {
    switch (this.patientDifficultyEnum) {
      case '00000000-0000-0000-0000-000000000000':
        this.patientDifficultyEnum = '00000107-1000-0000-0000-000000000001';
        break;
      case '00000107-1000-0000-0000-000000000001':
        this.patientDifficultyEnum = '00000107-1000-0000-0000-000000000002';
        break;
      case '00000107-1000-0000-0000-000000000002':
        this.patientDifficultyEnum = '00000107-1000-0000-0000-000000000003';
        break;
      case '00000107-1000-0000-0000-000000000003':
        this.patientDifficultyEnum = '00000000-0000-0000-0000-000000000000';
        break;
    }

    this.globals.ThePatient.enumPatientDifficultyLevelID = this.patientDifficultyEnum;
    this.patientService.saveDataPatient(this.globals.ThePatient).subscribe((resp) => {
      //
    });
  }

  onSearchPatientClick() {
    this.isShowPatientSearch = !this.isShowPatientSearch;
    setTimeout(() => {
      this.patientInputSearch.focus();
    }, 100);
  }

  closeSearch() {
    this.isShowPatientSearch = false;
    this.patientSearchList = [];
  }

  isUserHasRole(role: string) {
    switch (role) {
      case 'notes':
        return this.authenticationService.currentUserRolesIds.includes(UserRoleEnum.Notes) || this.authenticationService.currentUserRolesIds.includes(UserRoleEnum.NotesViewOnly);
    }
  }
  checkedOutState() {
    this.isActionCheckOut = true;
  }
  onRightMouseClick(event: MouseEvent, title: string, type: string) {
    this.openContext(event, this.pasteMenu, null);
  }

  // Context menu
  // Context boilerplate
  openContext({ x, y }: MouseEvent, template: TemplateRef<any>, data: any, closeOnItemClick = true): void {
    this.isContextOpen = true;
    this.closeContext();
    x = x + 50;
    y = y - 20;
    const positionStrategy = this.overlay.position().flexibleConnectedTo({ x, y }).withPositions([
      {
        originX: 'end',
        originY: 'bottom',
        overlayX: 'end',
        overlayY: 'top'
      }
    ]);

    this.overlayRef = this.overlay.create({
      positionStrategy,
      scrollStrategy: this.overlay.scrollStrategies.close()
    });

    this.overlayRef.attach(new TemplatePortal(template, this.viewContainerRef, { $implicit: data }));

    this.sub = fromEvent<MouseEvent>(document, 'click')
      .pipe(
        filter(event => {
          if (closeOnItemClick) {
            this.closeContext();
          } else {
            const clickTarget = event.target as HTMLElement;
            return !!this.overlayRef && !this.overlayRef.overlayElement.contains(clickTarget);
          }
        }), take(1)).subscribe(() => this.closeContext());
  }

  closeContext(): void {
    this.sub !== undefined && this.sub.unsubscribe();
    if (this.overlayRef) {
      this.isContextOpen = false;
      this.overlayRef.dispose();
      this.overlayRef = null;
    }
  }

  onAcquire() {
    const tags: string[] = [];
    // Patient Picture tag
    tags.push(DOCUMENT_TAG.PatientPicture);
    localStorage.setItem('tags-imaging', JSON.stringify(tags));
    this.uiService.openAcquireDefaultDevice(tags);
  }
}
